import { Layout, Section } from 'layout';
import { CreditFacilitiesListScreen } from 'pages/bnpl/screens/credit-facilities-list-screen';
import { CreditFacilityDetailScreen } from 'pages/bnpl/screens/credit-facility-detail-screen';
import { CreditUtilizationDetailScreen } from 'pages/bnpl/screens/credit-utilization-detail-screen';
import { CreditUtilizationsListScreen } from 'pages/bnpl/screens/credit-utilizations-list-screen';
import { SupplierStatementDetailScreen } from 'pages/bnpl/screens/supplier-statement-detail-screen';
import { SupplierStatementsListScreen } from 'pages/bnpl/screens/supplier-statements-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const BnplPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/credit-facilities`} />
          <Route path={`${match.url}/credit-facilities`} exact component={CreditFacilitiesListScreen} />
          <Route path={`${match.url}/credit-facilities/:id`} component={CreditFacilityDetailScreen} />
          <Route path={`${match.url}/credit-utilizations`} exact component={CreditUtilizationsListScreen} />
          <Route path={`${match.url}/credit-utilizations/:id`} component={CreditUtilizationDetailScreen} />
          <Route path={`${match.url}/supplier-statements`} exact component={SupplierStatementsListScreen} />
          <Route path={`${match.url}/supplier-statements/:id`} component={SupplierStatementDetailScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default BnplPage;
